import { Directive, ElementRef, EventEmitter, Output, Input, OnDestroy, OnInit } from '@angular/core';
import { LazyLoadOptionsInterface } from './lazy-load.interface';

@Directive({
    selector: '[lazyLoad]',
    standalone: false
})
export class LazyLoadDirective implements OnInit, OnDestroy {
    @Input('lazyLoad') public lazyOptions: LazyLoadOptionsInterface;
    @Output() public lazyCall: EventEmitter<boolean> = new EventEmitter();

    private _intersectionObserver?: IntersectionObserver;

    private get _featureActive(): boolean {
        return (
            'IntersectionObserver' in window &&
            'IntersectionObserverEntry' in window &&
            'isIntersecting' in IntersectionObserverEntry.prototype
        );
    }

    constructor(private _element: ElementRef) {}

    public ngOnInit() {
        if (this._featureActive) {
            const _options = this.lazyOptions || {};
            this._intersectionObserver = new IntersectionObserver((entries) => {
                this.checkForIntersection(entries);
            }, _options);
            this._intersectionObserver.observe(<Element>this._element.nativeElement);
        } else {
            this.lazyCall.emit(true);
        }
    }

    public ngOnDestroy() {
        try {
            if (this._featureActive) {
                this._intersectionObserver.unobserve(<Element>this._element.nativeElement);
                this._intersectionObserver.disconnect();
            }
        } catch (e) {}
    }

    private checkForIntersection = (entries: Array<IntersectionObserverEntry>) => {
        entries.forEach((entry: IntersectionObserverEntry) => {
            if (this.checkIfIntersecting(entry)) {
                this.lazyCall.emit(true);
                this._intersectionObserver.unobserve(<Element>this._element.nativeElement);
                this._intersectionObserver.disconnect();
            }
        });
    };

    private checkIfIntersecting(entry: IntersectionObserverEntry) {
        return (<any>entry).isIntersecting && entry.target === this._element.nativeElement;
    }
}
